import { render, staticRenderFns } from "./HelperTaxRegNo.vue?vue&type=template&id=74529e23&"
import script from "./HelperTaxRegNo.vue?vue&type=script&lang=ts&"
export * from "./HelperTaxRegNo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74529e23')) {
      api.createRecord('74529e23', component.options)
    } else {
      api.reload('74529e23', component.options)
    }
    module.hot.accept("./HelperTaxRegNo.vue?vue&type=template&id=74529e23&", function () {
      api.rerender('74529e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InputTaxRegNo/HelperTaxRegNo.vue"
export default component.exports